import React, { useState } from 'react';
import styled from 'styled-components';
import { Stack } from '../Stack';
import { RadioCardContext } from './hook';
const Container = styled(Stack)(({ theme, fullWidth, noWrap, variant, space }) => `
  width: ${fullWidth ? '100%' : 'inherit'};
  max-width: ${fullWidth ? 'none' : '730px'};
  display: inline-flex;
  flex-wrap: ${noWrap ? 'nowrap' : 'wrap'};
  gap: ${theme.space[space]};
  justify-content: center;

  & input[type='radio']:not(:checked) + label {
    margin: 1px;  
  }

  & input[type='radio']:checked + label {
    background-color: ${variant === 'emphasized' ? theme.colors.success : theme.colors.white};
    border-width: 2px;
    border-color: ${theme.colors.success};
    color: ${variant === 'emphasized' ? theme.colors.white : theme.colors.success};
  }
  & input[type='radio']:disabled + label {
    color: ${theme.colors.gray300};
    border-color: transparent;
    cursor: not-allowed;
    &:hover {
      box-shadow: none;
    }
  }
`);
export const RadioCard = ({ children, name, defaultValue = '', value: customValue, onChange: customOnChange, space = 'x8', px, py, variant = 'normal', fullWidth = false, noWrap = false, }) => {
    const [value, setValue] = useState(defaultValue || '');
    const onChange = !!customValue && customOnChange
        ? customOnChange
        : (newValue) => setValue(newValue);
    return (React.createElement(RadioCardContext.Provider, { value: {
            name,
            onChange,
            value: !!customValue && customOnChange ? customValue : value,
            variant,
            fullWidth,
            px,
            py,
        } },
        React.createElement(Container, { layout: "horizontal", margin: "x0", fullWidth: fullWidth, variant: variant, space: space, noWrap: noWrap }, children)));
};
//# sourceMappingURL=RadioCard.js.map